module.exports = __webpack_public_path__ + "static/img/crmdown1.b87e8d2.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/center/crmdown1.png
// module id = o/QP
// module chunks = 89